import React from 'react';

import {
  TableContainer, Table, TableHead, TableRow, TableCell, TableBody, makeStyles, TextField, Button,
} from '@material-ui/core';

const useStyles = makeStyles({
  table: {
    minWidth: 650,
  },
});

const CarrierList = () => {
  const classes = useStyles();

  const carriers = [
    {
      label: 'YRC',
    },
    {
      label: 'Southeastern Freight Lines',
    },
  ];

  return (
    <TableContainer>
      <Table className={classes.table} aria-label="simple table">
        <TableHead>
          <TableRow>
            <TableCell>Name</TableCell>
            <TableCell>Actions</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {carriers.map((carrier) => (
            <TableRow key={carrier.label}>
              <TableCell component="th" scope="row">
                {carrier.label}
              </TableCell>
              <TableCell component="th" scope="row">
                <Button variant="contained">Delete</Button>
              </TableCell>
            </TableRow>
          ))}
          <TableRow key="AddItem">
            <TableCell component="th" scope="row">
              <TextField required id="standard-required" label="Required" />
            </TableCell>
            <TableCell component="th" scope="row">
              <Button variant="contained">Add</Button>
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default CarrierList;
